<template>
  <div o-Container>
    <div class="headPanel">
      <div class="logo" v-on:click="openNewWindow">&nbsp;</div>
      <!--      <div class="title">&nbsp;</div>-->
    </div>
    <div class="registerPanel" v-if="isAuthorization">
      <div class="searchPanel">
        <div class="identityNumberBox">
          <el-input v-model="identityValue" v-on:change="change" placeholder="请输入身份证号"
                    :show-word-limit="true" slot="reference"
                    v-bind="{disabled:fasle,type:'text',maxlength:19}"></el-input>
        </div>
        <div class="searchButton">
          <el-button type="success" v-on:click="searchStudent">输入身份证号读取学生信息</el-button>
        </div>
      </div>
      <o-item v-bind:source="item.parent"></o-item>
      <o-item v-bind:source="item.student" v-bind="{successed:success}"></o-item>
      <div class="saveButton">
        <el-button type="warning" :disabled="showSaveButton" v-on:click="saveStudent">登记&绑定学生信息</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "mms_platform_student_list", /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    data() {
      return {
        octopus: this.$parent.octopus,
        item: {
          student: {
            // 以下参数默认由组件内部创建，但是如果有需要，开发人员可在这里提前设置，组件将按照您的预期渲染。
            data: {
              id: 698,
              value: "",
              cellData: [
                {name: "ClassID"},//编码
                {name: "Code"},// 学号
                {name: "Name"},// 学生姓名
                {name: "IdentityNumber"},
                {name: "Birthday"},
                {name: "Sex"},
                {name: "Age"},
                {name: "SensorID"},// 传感器ID
                {name: "TeenMode"},
                {name: "Height"},
                {name: "Weight"},
                {name: "EmergencyContact"},
                {name: "EmergencyContactMobile"},
                // {name: "CreateDate"},
                {name: "PhotoData"},
              ]
            },
          },
          parent: {
            data: {
              id: 241, // 菜单表的八爪鱼ID
              cellData: [
                {name: "StudentID"},
                {name: "RelationshipID"},// 所属关系
                {name: "ParentName",},// 所属家长
                {name: "ParentSex",},// 所属家长
                {name: "ParentMobile",},// 所属家长
              ],
            },
          },
        },
        identityValue: "",// 身份证号
        showSaveButton: true, // 启用保存按钮
        isAuthorization: false,
      }
    },
    created: function () {
      this.init();
    },
    methods: {
      init: function () {
        // 自动登陆
        this.octopus.passport.name = "qjyz";
        this.octopus.passport.password = "qjyz";
        this.octopus.passport.timespan = (new Date()).valueOf();
        this.octopus.passport.password = this.octopus.tools.md5(this.octopus.passport.name
          + "marco" + this.octopus.passport.timespan + "july" + this.octopus.passport.password);

        let o = this;
        // 获取护照数据，不管成功与否，全部设置为true。
        this.octopus.request.security.passport.get(function (passport_data) {
          o.octopus.passport.encryption = true;
          if (!o.octopus.tools.IsNullOrEmpty(passport_data) && passport_data.status.code == 200) {
            o.octopus.request.security.token.get(function (token_data) {
              if (!o.octopus.tools.IsNullOrEmpty(token_data) && token_data.status.code == 200) {
                // 获得授权后加载注册界面。
                o.isAuthorization = true;
                // 绑定过滤班级
                // alert(o.octopus.passport.project);
                o.octopus.tools.parseCell(o.item.student.data, "ClassID").link = [{mapping: "ProjectID", value: 27}];

                setTimeout(function () {
                  o.item.student.control.load();
                  o.item.parent.control.load();
                }, 100);

              } else {
                o.octopus.tips.error(token_data);
              }
            });
          } else {
            o.octopus.tips.error(passport_data);
          }
        });
      },
      // 查询学生
      searchStudent: function () {
        let o = this;
        // alert(this.octopus.passport.project);
        // 身份证是否已经输入
        if (!this.octopus.tools.IsNullOrEmpty(this.identityValue)) {
          this.octopus.request.api.post("/Octopus/Engine/List", {
              id: 70, // 视图表
              cellData: [
                {name: "ID"},
                {name: "Name"}, // 学生姓名
                {name: "ProjectID", filterKey: "=", filterValue: this.octopus.passport.project}, // 过滤项目
                {name: "IdentityNumber", filterKey: "=", filterValue: this.identityValue}, // 过滤身份证
              ],
            },
            (data) => {
              if (data.status.code === 200) {
                if (data.content.queryData.length == 1) {
                  let studentID = data.content.queryData[0].ID;
                  // alert(JSON.stringify(data.content.queryData[0]));
                  o.item.student.data.value = studentID;
                  o.item.student.control.load();
                  o.showSaveButton = false;

                } else {
                  // o.octopus.tips.error(JSON.stringify(data.status));
                  o.octopus.tips.error("请输入正确的学号。");
                }
              } else {
                o.octopus.tips.error(data);
              }
            }
          );

        } else {
          this.octopus.tips.error("请输入身份证号，再查询。");
        }
      },
      saveStudent: function () {
        let o = this;
        let ParentRelationship = this.octopus.tools.parseCell(this.item.parent.data, "RelationshipID").defaultValue;
        // 保存家长数据
        this.saveParent(function (parentID) {
          // 保存家长学生关系数据（视图用）
          o.octopus.request.api.post("/Octopus/Engine/List", {
              id: 359,
              cellData: [
                {
                  name: "ParentID",
                  filterKey: "=",
                  filterValue: parentID, // 家长ID
                },
                {
                  name: "StudentID",
                  filterKey: "=",
                  filterValue: o.item.student.data.value // 学生ID
                }, // 性别
                {name: "RelationshipID"},
              ],
            },
            (data) => {
              if (data.status.code === 200) {
                let MappingID = null;
                let SaveType = "CREATE";
                // 如果找到
                if (data.content.queryData.length == 1) {
                  // 得到关系数据
                  let parentInfo = data.content.queryData[0];
                  // 保存ID
                  MappingID = parentInfo.ID;

                  // 关联关系已存在，直接返回对象。
                  // callback({id: parentInfo.ID});
                }

                // 如果存在则保存
                if (MappingID) {
                  SaveType = "UPDATE";
                }

                // 关联关系不存在，插入后返回。
                o.octopus.request.api.post("/Octopus/Engine/Item", {
                    id: 359,
                    type: SaveType,
                    value: MappingID,// null or value
                    cellData: [
                      {name: "ParentID", defaultValue: parentID}, // 家长ID
                      {name: "StudentID", defaultValue: o.item.student.data.value}, // 学生ID
                      {
                        name: "RelationshipID",
                        defaultValue: ParentRelationship
                      }, // 关系
                    ],
                  },
                  // 处理回调事件，通过分析data.status.code的状态来实现。
                  function (data) {
                    if (data.status.code === 200) {
                      // 保存成功，回调
                      // 保存学生数据
                      o.item.student.control.save();

                    } else {
                      o.octopus.tips.error("更新学生家长关系库错误，异常：" + data.status.message);
                    }
                  }
                );

              } else {
                o.octopus.tips.error("查询家长学生关系库错误，异常：" + data.status.message);
              }
            }
          );

        });

      },
      // 更新学生手环信息
      updateStudentInfo: function (data) {
        // 有传感器ID才更新名称
        let o = this;
        let sensorID = this.octopus.tools.parseCell(data, "SensorID").defaultValue; // 26
        let classID = this.octopus.tools.parseCell(data, "ClassID").defaultValue;   // 349

        // alert(sensorID + "|" + classID);
        // 如果有传感器数据，则下发
        if (!this.octopus.tools.IsNullOrEmpty(sensorID) && !this.octopus.tools.IsNullOrEmpty(classID)) {
          // 查询班级名称，准备下发用。
          this.octopus.request.api.post("/Octopus/Engine/Item", {
              id: 521,
              type: "SELECT",
              value: classID,
              cellData: [
                {name: "Name"},// 班级名称
                {name: "Code"},// 班级编码
                {name: "LevelID"},// 级别：铺位低端、高端；1年级、2年级
              ]
            },
            // 处理回调事件，通过分析data.status.code的状态来实现。
            function (classData) {
              let className = o.octopus.tools.parseCell(classData.content, "Name").defaultValue;
              // 更新学生姓名并下发
              let studentInfo = {
                "sensorID": sensorID,
                "type": "CLASSAndNAME",
                "data": {
                  "className": className,
                  "studentName": o.octopus.tools.parseCell(data, "Name").defaultValue,
                }
              };

              // 下发 content":{"data":null,"message":"下发指令级别为设备级，参数deviceId必填","status":500}}
              o.octopus.tools.openAPI("/ESB/Sensor/Wear/Data/Push", studentInfo, function (sendData) {
                if (sendData.status.code == 200) {
                  o.octopus.tips.success("学生信息已更新下发至手环。");
                } else {
                  o.octopus.tips.error(sendData.content.message);
                }
                // console.log("))))" + JSON.stringify(sendData));

                o.updateSensorInfo(sensorID, classID);
              });
            }
          );

        } else {
          this.octopus.tips.error("未绑定传感器，无法执行发送。");
        }
      },
      updateSensorInfo: function (sensorID, classID) {
        let o = this;

        let networkType = 2; // NB网络
        let systemModule = 0;
        let space = 32;// 校园
        let brandID = 0;//品牌
        let sensorType = 3;// 曲一中默认学生注册手环

        // 手表 - 01款、02款
        if (sensorType == 1 || sensorType == 2) {
          systemModule = 37; // 智能手表
          brandID = 58;
        }
        // 手环 - 03款
        else if (sensorType == 3) {
          systemModule = 34; // 智能手环
          brandID = 57;
        }
        // 判定是否在边界内
        if (systemModule > 0 && brandID > 0) {
          // 更新传感器表类型、品牌、所在搬家
          this.octopus.request.api.post("/Octopus/Engine/Item", {
              id: 64,
              type: "UPDATE",
              value: sensorID,
              cellData: [
                {name: "TypeID", defaultValue: networkType}, // 传感器ID
                {name: "BerthID", defaultValue: classID}, // 班级ID
                {name: "BrandID", defaultValue: brandID}, // 传感器ID
                {name: "SystemModuleID", defaultValue: systemModule}, // 传感器ID
                {name: "SpaceID", defaultValue: space}, // 传感器ID
              ],
            },
            // 处理回调事件，通过分析data.status.code的状态来实现。
            function (data) {
              // alert(sensorID + "," + classID + "," + JSON.stringify(data.status));
              if (data.status.code === 200) {
                o.octopus.tips.success("传感器数据已更新。");
              } else {
                o.octopus.tips.error("更新传感器库，异常：" + data.status.message);
              }
            }
          );
        }
        // 未解析
        else {
          this.octopus.tips.error("未知的设备，请联系管理员。");
        }

      },
      // 保存家长信息
      saveParent: function (callback) {
        let o = this;
        let ParentName = this.octopus.tools.parseCell(this.item.parent.data, "ParentName").defaultValue;
        let ParentSex = this.octopus.tools.parseCell(this.item.parent.data, "ParentSex").defaultValue;
        let ParentMobile = this.octopus.tools.parseCell(this.item.parent.data, "ParentMobile").defaultValue;

        // alert(ParentName + "," + ParentSex + "," + ParentMobile);
        // 保存家长数据
        this.octopus.request.api.post("/Octopus/Engine/List", {
            id: 1,
            cellData: [
              {
                name: "StudentID", // 学生ID
                filterKey: "=",
                filterValue: this.item.student.data.value
              },
              {
                name: "Name", // 家长账号，后续要测试是否你吃
                filterKey: "=",
                filterValue: ParentMobile,
              },
            ],
          },
          (data) => {
            if (data.status.code === 200) {
              // 如果找到
              if (data.content.queryData.length == 1) {
                // 得到关系数据
                let parentInfo = data.content.queryData[0];
                // 将家长ID传回
                callback(parentInfo.ID);
              }
              // 创建家长
              else {
                // 创建架构分组，同样的代码在Campus/User/Student.vue 的 235行
                let parentData = {};
                // 总公司 架构
                if (o.octopus.passport.authorization.company == 1) {
                  parentData = {
                    companyID: 1,
                    departmentID: 23,
                    roleID: 48
                  }
                }
                // 曲一架构
                else if (o.octopus.passport.authorization.company == 12) {
                  parentData = {
                    companyID: 12,
                    departmentID: 8,
                    roleID: 40
                  }
                }

                this.octopus.request.api.post("/Octopus/Engine/Item", {
                    id: 1,
                    type: "CREATE",
                    cellData: [
                      {name: "CompanyID", defaultValue: parentData.companyID},
                      {name: "DepartmentID", defaultValue: parentData.departmentID},
                      {name: "RoleID", defaultValue: parentData.roleID},
                      {name: "Name", defaultValue: ParentMobile},
                      {name: "Password", defaultValue: "Octopus_" + ParentMobile},
                      {name: "RealName", defaultValue: ParentName},
                      {name: "NickName", defaultValue: ParentName},
                      {name: "Mobile", defaultValue: ParentMobile},
                      {name: "Sex", defaultValue: ParentSex},
                      {name: "TypeID", defaultValue: 2},
                    ],
                  },
                  // 处理回调事件，通过分析data.status.code的状态来实现。
                  function (data) {
                    if (data.status.code === 200) {
                      callback(o.octopus.tools.parseCell(data.content, "ID").defaultValue);
                    } else {
                      o.octopus.tips.error(data);
                    }
                  }
                );
              }

            } else {
              o.octopus.tips.error("创建家长信息错误：" + data.status.message);
            }
          }
        );
      },
      success: function (data) {
        if (data.content.type != "SELECT") {
          // 下发学生姓名
          this.updateStudentInfo(data.content);

          // this.showSaveButton = true;
          // this.identityValue = null;
          // this.item.student.data.value = null;
          // this.item.student.control.load();
          // this.item.parent.data.value = null;
          // this.item.parent.control.load();
          //
          alert("绑定成功，请确认手环收到姓名后再关闭本浏览器。");
        }
      },
      openNewWindow: function () {
        window.open(location.href, "_blank");
      },
    },
    props: ["oData"]
  }
</script>




// WEBPACK FOOTER //
// src/components/Main/App/Campus/Register/qjyz.vue